import { Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { CardsView, JobSearch } from "../../../../Constants/Constants";
import LeftSidebar from "../Common/LeftSidebar";
import RightSidebarCards from "../Common/RightSidebarCards";

const CardsViewContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={CardsView} parent={JobSearch} />
      <Container fluid>
        <Row>
          <LeftSidebar />
          <Col xl="9" className="xl-60 box-col-12">
            <Row>
              <RightSidebarCards startLimit={0} colClass="col-xl-6 xl-100" />
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CardsViewContainer;
